import dayjs from 'dayjs';
import _ from 'lodash';

import { COMMON_DATETIME_FORMAT, COMMON_DATETIME_FORMAT_FOR_FILE_NAME } from 'constants/date';
import { AusOperationStatus } from 'constants/loanApplication';

export const checkIsAusSummaryRefreshRequired = status =>
  [AusOperationStatus.COMPLETED, AusOperationStatus.ERROR].includes(status);

export const formatAusFindingsOptions = data => {
  const formattedData = data.map(({ submissionDate, submissionNumber, documentId }) => {
    const submissionDateDayJs = dayjs(submissionDate || undefined);
    const viewSubmissionDate = submissionDateDayJs.format(COMMON_DATETIME_FORMAT);
    const downloadSubmissionDate = submissionDateDayJs.format(COMMON_DATETIME_FORMAT_FOR_FILE_NAME);
    const name = [submissionNumber, viewSubmissionDate].filter(Boolean).join(' - ');
    const downloadName = `${[submissionNumber, downloadSubmissionDate]
      .filter(Boolean)
      .join(' - ')}.pdf`;

    return {
      name,
      value: documentId,
      viewSubmissionDate,
      downloadName,
    };
  });

  return _.orderBy(formattedData, ({ viewSubmissionDate }) => new Date(viewSubmissionDate), 'desc');
};
